// extracted by mini-css-extract-plugin
module.exports = {"layout":"QuickDepositPopup__layout--1jw","popup":"QuickDepositPopup__popup--3Po"};